export default class Navbar {
   constructor() {
      this.navbar = document.querySelector('.navbar')
      this.init()
   }

   init() {
      if (this.navbar) {
         this.pin()
         document.addEventListener('scroll', () => this.pin())
      }
   }

   pin() {
      const offset = this.navbar.offsetHeight
      window.pageYOffset > offset
         ? this.navbar.classList.add('navbar--scrolled')
         : this.navbar.classList.remove('navbar--scrolled')
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/navbar.js
// module id = 10
// module chunks = 0